import {queryOptions} from '@tanstack/react-query';
import {programsAdmissionsList} from 'api/v2';
import type {ProgramsAdmissionsListParams} from 'api/v2';

export const programAdmissionsQueryKeys = {
  all: () => ['programAdmissions'],
  lists: () => [...programAdmissionsQueryKeys.all(), 'list'],
  list: (params: ProgramsAdmissionsListParams) => [
    ...programAdmissionsQueryKeys.lists(),
    params,
  ],
};

const programAdmissionsAll = (params: ProgramsAdmissionsListParams) =>
  queryOptions({
    queryKey: programAdmissionsQueryKeys.list(params),
    queryFn: () => programsAdmissionsList(params),
    select: (data) => data.data,
  });

export const programAdmissionsQueryOptions = {
  list: programAdmissionsAll,
};
